/** Canonical organization-settings path with the workspace id kept off the path. */
export const ORGANIZATION_SETTINGS_PATH = '/workspaces/organization-settings'

/** Query param used by deep links / the other branch to restore currentWorkspace. */
export const ORGANIZATION_SETTINGS_WORKSPACE_QUERY_PARAM = 'workspace_id'

/**
 * Build the default organization-settings URL. No workspace id is added.
 * @param {string | null} [fragment] Optional hash fragment without a leading `#`
 * @returns {string} Canonical relative URL
 */
export function getOrganizationSettingsUrl(fragment?: string | null): string {
  const hash = fragment ? `#${String(fragment).replace(/^#/, '')}` : ''
  return `${ORGANIZATION_SETTINGS_PATH}${hash}`
}
